<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{(editMode)?'Редактировать статистику':'Добавить статистику'}}
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-tabs slot="extension" v-model="tab" slider-color="primary" color="panel" dark>
        <v-tab href="#params">Параметры</v-tab>
        <v-tab href="#performers">Объекты</v-tab>
        <v-tab href="#admins">Администраторы</v-tab>
        <v-tab href="#fillers">Заполняющие</v-tab>
        <v-tab href="#watchers">Наблюдатели</v-tab>
        <v-tab href="#input">Настройка ввода</v-tab>
        <v-tab href="#output">Настройка вывода</v-tab>
        <v-tab href="#owner">Владение</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item class="mt-2" value="params">
          <v-container grid-list-xl class="pa-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="statistic.name" label="Название"></v-text-field>
              </v-flex>
              <v-flex xs12 class="py-0">
                <div class="mb-3">
                  <label class="v-label theme--light" style="font-size: 13px">Описание</label>
                  <dantser-editor v-model="statistic.description" :init="config" :api-key="apiKey"></dantser-editor>
                </div>
              </v-flex>
              <v-flex xs12>
                <dantser-tree
                  label="Родительская папка"
                  :source="foldersTree"
                  ref="parentFolder"
                  :field="true"
                  :selectMode="1"
                  @node-dblclick="setFolder($event)"
                >
                </dantser-tree>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select :items="periods" label="Период по умолчанию" v-model="statistic.period_type" hide-details no-data-text="Значения отсутствуют"></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-model="statistic.unit" label="Единица измерения(кратко)" placeholder="Например, кг." hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox label="Перевернутый график" v-model="statistic.invert_chart" hide-details></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
  
        <v-tab-item class="mt-2" value="performers">
          <object-scope :treedata="treedata" :deleted_objects="statistic.deleted_objects" v-model="statistic.label_objects" 
                        @addObject="addObject" @deleteObj="deleteObj" @restoreObjects="restoreObjects"></object-scope>
        </v-tab-item>
        
        <v-tab-item class="mt-2" value="admins">
          <dantser-scope :treedata="treedata" v-model="statistic.admins_data"></dantser-scope>
        </v-tab-item>
  
        <v-tab-item class="mt-2" value="fillers">
          <dantser-scope :treedata="treedata" v-model="statistic.fillings_data"></dantser-scope>
        </v-tab-item>
  
        <v-tab-item class="mt-2" value="watchers">
          <dantser-scope :treedata="treedata" v-model="statistic.watchers_data"></dantser-scope>
        </v-tab-item>
  
        <v-tab-item class="mt-2" value="input">
          <input-settings v-model="statistic.settings_input" :objects="statistic.label_objects"></input-settings>
        </v-tab-item>
        
        <v-tab-item class="mt-2" value="output">
          <output-settings v-model="statistic.settings_output" :objects="statistic.label_objects" output></output-settings>
        </v-tab-item>
  
        <v-tab-item class="mt-2" value="owner">
          <v-flex xs12 class="mt-3" v-if="owner && owner.name">
            <b>Текущий владелец</b>
            <p class="ma-0">{{owner.name}}</p>
          </v-flex>
          <v-flex xs12 class="mt-3" v-if="transfer && transfer.name">
            <v-alert :value="true" type="info">
              <p class="body-2">Находится в состоянии передачи владения пользователю {{transfer.name}}</p>
              <v-btn color="error" small @click="cancelTransfer">Отменить</v-btn>
            </v-alert>
          </v-flex>
          <dantser-tree v-else-if="!editMode || isOwner"
            label="Выберите пост для передачи владения"
            :field="true"
            :checkbox="false"
            :selectMode="1"
            :source="treedata"
            @node-dblclick="setOwner($event)"
          ></dantser-tree>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="saveIndicator" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  const uuidRegexpPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  const uuidv4 = require('uuid/v4')
  
  let defaultUUID = uuidv4()
  
  import {mapGetters, mapState} from 'vuex'
  import ObjectScope from '../../Common/ObjectScope'
  import InputSettings from '../../Common/InputSettings'
  import OutputSettings from '../../Common/OutputSettings'
  
  export default {
    name : 'IndicatorForm',
    
    components: {
      ObjectScope,
      InputSettings,
      OutputSettings
    },
    
    props:{
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          description: '',
          parent_id: null,
          unit: '',
          period_type: 1,
          invert_chart: false,
          admins_data: [],
          watchers_data: [],
          fillings_data: [],
          label_objects: [{
            "id": defaultUUID,
            "element_type": "outer",
            "identified": "По умолчанию",
            "name": "По умолчанию",
            "visible": true
          }],
          deleted_objects: [],
          settings_input: [{
            name: 'По умолчанию',
            type: 0,
            objects: [{
              object_id: defaultUUID,
              element_type: 'outer',
              identified: 'По умолчанию'
            }]
          }],
          settings_output: [{
            color: '#0288d1',
            name: 'По умолчанию',
            line: [{
              type: 0,
              objects: [{
                object_id: defaultUUID,
                element_type: 'outer',
                identified: 'По умолчанию'
              }]
            }],
          }],
          transfer: null
        }}
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      },
      type: {
        type: Number,
        required: false,
        default: 0
      },
      parent_id: {
        type: String,
        required: false,
      }
    },
  
    computed:{
      ...mapState('analytics', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
      ...mapState(`app/account`, ['postId']),
      ...mapGetters('app/org', ['getPostById','getContainerById']),
      
      isOwner(){
        return (this.owner && this.owner.id===this.postId)
      }
    },
    
    created(){
      defaultUUID = uuidv4()
    },
    
    mounted(){
      this.statistic = JSON.parse(JSON.stringify(this.data))
      let parent_id = 0
      if(this.editMode){
        parent_id = (this.type===0 || this.statistic.parent_id==null) ? 0 : this.statistic.parent_id
        this.getParticipants(this.statistic.id, 'all')
      }
      this.getTree(parent_id)
    },
    
    data() {
      return {
        statistic: {},
        tab: null,
        treedata: [],
        foldersTree: [],
        owner: null,
        transfer: null,
        status:{
          btnDisabled: false,
          text: '',
          className:'success--text darken-1'
        },
        periods: [
          { value: 0, text: 'Час' },
          { value: 1, text: 'День' },
          { value: 2, text: 'Неделя' },
          { value: 3, text: 'Месяц' }
        ],
      }
    },
    
    methods : {
      getTree(parent_id){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
        })
        this.$store.dispatch('analytics_old/indicators/getFolders', {id: parent_id, type: this.type}).then( response => {
          this.foldersTree = response
          this.foldersTree.unshift({
            id: null,
            name: 'Не выбрано',
            icon: 'mdi mdi-square'
          })
          if(this.parent_id){
            this.statistic.parent_id = this.parent_id
          }
          this.$nextTick(function(){
            this.$refs['parentFolder'].setSelected(this.statistic.parent_id)
          })
        })
      },
  
      getParticipants(id, type){
        this.$store.dispatch('analytics_old/indicators/getParticipants', {id, type}).then( response => {
          if(response.admins_data) this.$set(this.statistic, 'admins_data', response.admins_data)
          if(response.watchers_data) this.$set(this.statistic, 'watchers_data', response.watchers_data)
          if(response.fillings_data) this.$set(this.statistic, 'fillings_data', response.fillings_data)
          if(response.label_objects) this.$set(this.statistic, 'label_objects', response.label_objects)
          if(response.deleted_objects) this.$set(this.statistic, 'deleted_objects', response.deleted_objects)
          if(response.settings_input) this.$set(this.statistic, 'settings_input', response.settings_input)
          if(response.settings_output) this.$set(this.statistic, 'settings_output', response.settings_output)
          if(response.transfer && response.transfer.id) this.$set(this.statistic, 'transfer', response.transfer)
          this.transfer = response.transfer
          this.owner = response.owner
          
          this.convertStatisticObjects()
          this.setSettingsObjectsNames()
        })
      },
      
      convertStatisticObjects(){
        let posts = []
        let containers = []
        this.statistic.admins_data.map( item => {
          if(item.element_type==='post'){
            let post = this.getPostById(item.element_id)
            if(post.loaded){
              item.name = post.name
            } else if(!posts.includes(item.element_id)){
              posts.push(item.element_id)
            }
          } else if(item.element_type==='container'){
            let container = this.getContainerById(item.element_id)
            if(container.loaded){
              item.name = container.name
            } else if(!containers.includes(item.element_id)){
              containers.push(item.element_id)
            }
          }
        })
  
        this.statistic.fillings_data.map( item => {
          if(item.element_type==='post'){
            let post = this.getPostById(item.element_id)
            if(post.loaded){
              item.name = post.name
            } else if(!posts.includes(item.element_id)){
              posts.push(item.element_id)
            }
          } else if(item.element_type==='container'){
            let container = this.getContainerById(item.element_id)
            if(container.loaded){
              item.name = container.name
            } else if(!containers.includes(item.element_id)){
              containers.push(item.element_id)
            }
          }
        })
  
        this.statistic.watchers_data.map( item => {
          if(item.element_type==='post'){
            let post = this.getPostById(item.element_id)
            if(post.loaded){
              item.name = post.name
            } else if(!posts.includes(item.element_id)){
              posts.push(item.element_id)
            }
          } else if(item.element_type==='container'){
            let container = this.getContainerById(item.element_id)
            if(container.loaded){
              item.name = container.name
            } else if(!containers.includes(item.element_id)){
              containers.push(item.element_id)
            }
          }
        })
  
        //Запрос к оргструктуре на получение имен постов и вставка их в соответствующие места в заголовках таблицы
        if(posts.length>0 || containers.length>0){
          this.$store.dispatch('app/org/entitiesInfo', { posts, containers}).then( response => {
            //Запись постов в хранилище, чтобы не запрашивать при возможной отрисовке следующей таблицы
            this.$store.commit('app/org/addPosts', response.posts_data)
            this.$store.commit('app/org/addContainers', response.containers_data)
            //Парсинг имен объектов и замена uuid на соответствующее название поста
            this.statistic.admins_data.map( item => {
              if(item.element_type==='post'){
                let post = this.getPostById(item.element_id)
                if(post.loaded){
                  item.name = post.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              } else if(item.element_type==='container'){
                let container = this.getContainerById(item.element_id)
                if(container.loaded){
                  item.name = container.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              }
            })
  
            this.statistic.fillings_data.map( item => {
              if(item.element_type==='post'){
                let post = this.getPostById(item.element_id)
                if(post.loaded){
                  item.name = post.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              } else if(item.element_type==='container'){
                let container = this.getContainerById(item.element_id)
                if(container.loaded){
                  item.name = container.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              }
            })
  
            this.statistic.watchers_data.map( item => {
              if(item.element_type==='post'){
                let post = this.getPostById(item.element_id)
                if(post.loaded){
                  item.name = post.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              } else if(item.element_type==='container'){
                let container = this.getContainerById(item.element_id)
                if(container.loaded){
                  item.name = container.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              }
            })
            
          })
        }
      },
  
      setOwner(node){
        this.statistic.transfer = node.id
      },
  
      cancelTransfer(){
        this.statistic.transfer = null
        this.transfer = null
      },
  
      saveIndicator(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
        
        if(this.editMode){
          this.$store.dispatch('analytics_old/indicators/update', this.statistic).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.$emit('save', {type: 'statistic', data: this.statistic})
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
          })
        } else {
          this.$store.dispatch('analytics_old/indicators/create', this.statistic).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.statistic.id = response.id
            this.statistic.icon = 'mdi mdi-finance'
            this.statistic.element_type = 'statistic'
            this.statistic.children = []
            this.$emit('save', {type: 'statistic', data: this.statistic})
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
          })
        }
      },
  
      setFolder(eventData){
        this.statistic.parent_id = eventData.id
      },
  
      addObject(item){
        this.statistic.settings_input.push({
          name: item.name,
          type: 0,
          objects:[
            {
              object_id: item.id,
              identified: item.identified,
              element_type: item.element_type
            }
          ]
        })
      },
  
      deleteObj(item){
        let index = this.statistic.settings_input.length - 1
        while(index>=0){
          let obj_ind = this.statistic.settings_input[index].objects.findIndex( el => el.object_id === item.id)
          if(obj_ind>-1){
            this.statistic.settings_input.splice(index, 1)
          }
          index--
        }
        let indx = this.statistic.settings_output.length - 1
        while(indx>=0){
          let exist = false
          this.statistic.settings_output[indx].line.map( line => {
            exist = line.objects.some( el => {
              return el.object_id === item.id
            })
          })
          if(exist) this.statistic.settings_output.splice(indx, 1)
          indx--
        }
      },
  
      restoreObjects(items){
        if(this.editMode){
          let id = this.statistic.id
          let objects_ids = []
          let data = { objects_ids }
          items.map( item => {
            objects_ids.push(item.id)
          })
          this.$store.dispatch('analytics_old/indicators/getLines', {id, data}).then( response => {
            if(response.input_lines) this.statistic.settings_input = this.statistic.settings_input.concat(response.input_lines)
            if(response.output_lines) this.statistic.settings_output = this.statistic.settings_output.concat(response.output_lines)
            this.setSettingsObjectsNames()
          })
        } else {
          items.map( item => {
            this.statistic.settings_input.push({
              name: item.name,
              type: 0,
              objects:[
                {
                  object_id: item.id,
                  identified: item.identified,
                  element_type: item.element_type
                }
              ]
            })
          })
        }
      },
  
      setSettingsObjectsNames(){
        let posts = []
        let containers = []
        
        this.statistic.settings_input.map(line => {
          let name = line.name
          line.objects.map( (el, index)=>{
            let temp_name = el.identified
            if(el.element_type==='post'){
              let post = this.getPostById(el.identified)
              if(post.loaded){
                temp_name = post.name
              } else{
                temp_name = '*post*'+temp_name
                if(!posts.includes(el.identified)){
                  posts.push(el.identified)
                }
              }
            } else if(el.element_type==='container'){
              let container = this.getContainerById(el.identified)
              if(container.loaded){
                temp_name = container.name
              } else{
                temp_name = '*cont*'+temp_name
                if(!containers.includes(el.identified)){
                  containers.push(el.identified)
                }
              }
            }
            let separator = (index===line.objects.length-1) ? '' : ' -> '
            name = name+temp_name+separator
          })
          line.name = name
        })
  
        this.statistic.settings_output.map(set=>{
          let name = ''
          set.line.map( (item,index) => {
            let temp = ''
            if(item.type===1){
              temp = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:19px"></i>('
            }
            item.objects.map( (obj, ind) => {
              obj.name = obj.identified
              if(obj.element_type==='post'){
                let post = this.getPostById(obj.identified)
                if(post.loaded){
                  obj.name = post.name
                } else if(!posts.includes(obj.identified)){
                  posts.push(obj.identified)
                }
              } else if(obj.element_type==='container'){
                let container = this.getContainerById(obj.identified)
                if(container.loaded){
                  obj.name = container.name
                } else if(!containers.includes(obj.identified)){
                  containers.push(obj.identified)
                }
              }
              let sep = (ind===item.objects.length-1) ? '' : '->'
              temp= temp + obj.name + sep
            })
            if(item.type===1) temp+=')'
            if(index!==set.line.length-1){
              temp+='<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>'
            }
            name+=temp
          })
          set.name = name
        })
  
        //Запрос к оргструктуре на получение имен постов и вставка их в соответствующие места в заголовках таблицы
        if(posts.length>0 || containers.length>0){
          this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
            //Запись постов в хранилище, чтобы не запрашивать при возможной отрисовке следующей таблицы
            this.$store.commit('app/org/addPosts', response.posts_data)
            this.$store.commit('app/org/addContainers', response.containers_data)
            //Парсинг имен объектов и замена uuid на соответствующее название поста
            this.statistic.settings_input.map( line => {
              let names = line.name.split(' -> ')
              for(let i=0;i<names.length;i++){
                if(names[i].indexOf('*post*')===0){
                  names[i] = names[i].substr(6)
                  let post = this.getPostById(names[i])
                  if(uuidRegexpPattern.test(names[i]) && post.loaded){
                    names[i] = post.name
                  }
                } else if(names[i].indexOf('*cont*')===0){
                  names[i] = names[i].substr(6)
                  let container = this.getContainerById(names[i])
                  if(uuidRegexpPattern.test(names[i]) && container.loaded){
                    names[i] = container.name
                  }
                }
              }
              line.name = names.join(' -> ')
            })
  
            this.statistic.settings_output.map(set => {
              let name = ''
              set.line.map( (item,index) => {
                let temp = ''
                if(item.type===1){
                  temp = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:19px"></i>('
                }
                item.objects.map( (obj, ind) => {
                  let sep = (ind===item.objects.length-1) ? '' : '->'
                  temp= temp + obj.name + sep
                })
                if(item.type===1) temp+=')'
                if(index!==set.line.length-1){
                  temp+='<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>'
                }
                name+=temp
              })
              set.name = name
            })
          })
        }
      },
    },
    
  }
</script>

<style>
  .object-level-panel.v-expansion-panel__container--active{
    background-color: #e0e0e0 !important;
    border-color: #e0e0e0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Forms/SimpleStatisticForm.vue